import React from 'react'
import './HeroImage.scss'
import { graphql, useStaticQuery } from 'gatsby'
import './HeroImage.scss'
import {GatsbyImage, getImage} from "gatsby-plugin-image";

const HeroImage = props => {
  const data = useStaticQuery(graphql`
    query {
      hi: file(
        relativePath: {
          eq: "our-work/league-of-legfaker-of-skt-t1-atlol-world-championship-at-the-staples-center-lol-world-championshipends-world-championships.jpg"
        }
      ) {
        childImageSharp {
          gatsbyImageData(width: 1333)
        }
      }
    }
  `)

  const image = getImage(data.hi.childImageSharp)
  return (
    <div className="hero-image--wrapper tags single-image">
      <div className="hero-image">
        <GatsbyImage image={image} alt="hero image" />
      </div>
    </div>
  )
}

export default HeroImage
